import {
  TSpoc,
  TSpocPremise,
  TPremise,
} from "../../apis/spocPremise/spocPremise.interfaces";

export const spocListMock: TSpoc[] = [
  {
    id: "spoc-1",
    instituteId: "1",
    name: "Dr. Rajesh Kumar",
    role: "Principal",
    email: "principal@dpsdelhi.edu.in",
    phone: "+919876543210",
    status: "primary",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "spoc-2",
    instituteId: "1",
    name: "Ms. Priya Sharma",
    role: "Vice Principal",
    email: "viceprincipal@dpsdelhi.edu.in",
    phone: "+919876543211",
    status: "secondary",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "spoc-3",
    instituteId: "1",
    name: "Mr. Amit Singh",
    role: "Administrative Officer",
    email: "admin@dpsdelhi.edu.in",
    phone: "+919876543212",
    status: "secondary",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "spoc-4",
    instituteId: "2",
    name: "Sister Mary Joseph",
    role: "Principal",
    email: "principal@stmarysacademy.edu.in",
    phone: "+919876543220",
    status: "primary",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "spoc-5",
    instituteId: "2",
    name: "Mr. John Fernandes",
    role: "Administrative Head",
    email: "admin@stmarysacademy.edu.in",
    phone: "+919876543221",
    status: "secondary",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const premiseListMock: TPremise[] = [
  {
    id: "premise-1",
    instituteId: "1",
    name: "Main Campus - DPS Delhi",
    address: "Mathura Road, New Delhi - 110076",
    phone: "+919876543210",
    email: "maincampus@dpsdelhi.edu.in",
    capacity: 2500,
    status: "active",
    operatingHours: {
      monday: { open: "08:00", close: "17:00", closed: false },
      tuesday: { open: "08:00", close: "17:00", closed: false },
      wednesday: { open: "08:00", close: "17:00", closed: false },
      thursday: { open: "08:00", close: "17:00", closed: false },
      friday: { open: "08:00", close: "17:00", closed: false },
      saturday: { open: "08:00", close: "13:00", closed: false },
      sunday: { open: "00:00", close: "00:00", closed: true },
    },
    facilities: [
      "Library",
      "Laboratory",
      "Computer Lab",
      "Sports Facilities",
      "Cafeteria",
      "Auditorium",
      "Parking",
      "Security",
      "WiFi",
      "Air Conditioning",
      "Playground",
    ],
    specialFeatures:
      "State-of-the-art science laboratories, Olympic-size swimming pool, and a fully equipped auditorium with 500-seat capacity.",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "premise-2",
    instituteId: "1",
    name: "East Wing - DPS Delhi",
    address: "East Delhi Extension, New Delhi - 110092",
    phone: "+919876543211",
    email: "eastwing@dpsdelhi.edu.in",
    capacity: 1200,
    status: "active",
    operatingHours: {
      monday: { open: "08:30", close: "16:30", closed: false },
      tuesday: { open: "08:30", close: "16:30", closed: false },
      wednesday: { open: "08:30", close: "16:30", closed: false },
      thursday: { open: "08:30", close: "16:30", closed: false },
      friday: { open: "08:30", close: "16:30", closed: false },
      saturday: { open: "00:00", close: "00:00", closed: true },
      sunday: { open: "00:00", close: "00:00", closed: true },
    },
    facilities: [
      "Library",
      "Computer Lab",
      "Cafeteria",
      "Parking",
      "Security",
      "WiFi",
    ],
    specialFeatures: "Dedicated art and music rooms with modern equipment.",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "premise-3",
    instituteId: "1",
    name: "North Campus - DPS Delhi",
    address: "Rohini Sector 24, New Delhi - 110085",
    phone: "+919876543212",
    email: "northcampus@dpsdelhi.edu.in",
    capacity: 1800,
    status: "active",
    operatingHours: {
      monday: { open: "08:00", close: "17:00", closed: false },
      tuesday: { open: "08:00", close: "17:00", closed: false },
      wednesday: { open: "08:00", close: "17:00", closed: false },
      thursday: { open: "08:00", close: "17:00", closed: false },
      friday: { open: "08:00", close: "17:00", closed: false },
      saturday: { open: "08:00", close: "13:00", closed: false },
      sunday: { open: "00:00", close: "00:00", closed: true },
    },
    facilities: [
      "Library",
      "Laboratory",
      "Computer Lab",
      "Sports Facilities",
      "Cafeteria",
      "Parking",
      "Security",
      "WiFi",
      "Playground",
      "Medical Room",
    ],
    specialFeatures: "Large sports complex with basketball and tennis courts.",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "premise-4",
    instituteId: "2",
    name: "St. Mary's Academy - Main Building",
    address: "Church Road, Mumbai - 400001",
    phone: "+919876543220",
    email: "mainbuilding@stmarysacademy.edu.in",
    capacity: 1500,
    status: "active",
    operatingHours: {
      monday: { open: "09:00", close: "16:00", closed: false },
      tuesday: { open: "09:00", close: "16:00", closed: false },
      wednesday: { open: "09:00", close: "16:00", closed: false },
      thursday: { open: "09:00", close: "16:00", closed: false },
      friday: { open: "09:00", close: "16:00", closed: false },
      saturday: { open: "09:00", close: "12:00", closed: false },
      sunday: { open: "00:00", close: "00:00", closed: true },
    },
    facilities: [
      "Library",
      "Laboratory",
      "Computer Lab",
      "Cafeteria",
      "Auditorium",
      "Parking",
      "Security",
      "WiFi",
      "Air Conditioning",
      "Medical Room",
    ],
    specialFeatures:
      "Historic building with modern amenities, featuring a chapel and heritage architecture.",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "premise-5",
    instituteId: "2",
    name: "St. Mary's Academy - Annex",
    address: "Annex Building, Mumbai - 400001",
    phone: "+919876543221",
    email: "annex@stmarysacademy.edu.in",
    capacity: 800,
    status: "inactive",
    operatingHours: {},
    facilities: [],
    specialFeatures: "",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const spocPremiseListMock: TSpocPremise[] = [{ id: "1" }];

export const spocPremiseMock: TSpocPremise = { id: "1" };
